/**
 * HTTP 客户端导出模块
 *
 * 提供两个预设实例：
 * - http: 用户端 HTTP 客户端（携带 access_token，401 跳转 /login）
 * - csHttp: 客服端 HTTP 客户端（携带 cs_access_token，401 跳转 /csLogin）
 *
 * @example
 * // 用户端 API
 * import { http } from '@/utils/http';
 * const data = await http.post('/api/user/info', data);
 *
 * // 客服端 API
 * import { csHttp } from '@/utils/http';
 * const data = await csHttp.post('/api/cs/user/info', data);
 */
import { createHttpClient } from './httpClient';
import { createRequest } from './request';

// ==================== 创建预设实例 ====================

/** 用户端 HTTP 客户端 */
const userHttpClient = createHttpClient({ type: 'user' });
/** 客服端 HTTP 客户端 */
const csHttpClient = createHttpClient({ type: 'cs' });

// ==================== 导出请求方法 ====================

/** 用户端请求方法（携带 access_token） */
export const http = createRequest(userHttpClient);

/** 客服端请求方法（携带 cs_access_token） */
export const csHttp = createRequest(csHttpClient);

// ==================== 导出 axios 实例（特殊情况直接使用） ====================

/** 用户端 axios 实例 */
export const httpInstance = userHttpClient;

/** 客服端 axios 实例 */
export const csHttpInstance = csHttpClient;

// ==================== 导出类型 ====================

export type { HttpClientType, HttpClientConfig, HttpClient } from './types';
export { BizError } from './types';
